export enum FavoriteContentOrder {
  LatestFavorite = 'LatestFavorite',
  EpisodeUpdated = 'EpisodeUpdated',
}

export const FavoriteContentOrderText = {
  [FavoriteContentOrder.LatestFavorite]: '등록순',
  [FavoriteContentOrder.EpisodeUpdated]: '업데이트순',
} as Record<FavoriteContentOrder, string>;
